export default "__VITE_ASSET__BmDsvuQv__"